import * as React from "react";
import {PluginTemplates} from "@falcon/plugin-falcon-journey";
import {IWithRouterProps, withRouter} from "@athena-portal/components";

interface IAggregatorErrorPageParams {
    aggregator: string;
    [key: string]: string | undefined;
}

export class AggregatorErrorPagePlain extends React.Component<IWithRouterProps<IAggregatorErrorPageParams>> {

    private pluginTemplates = new PluginTemplates();

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Aggregator Error");
    }

    public render() {
        return (
            <React.Fragment>
                {this.pluginTemplates.renderHeader()}
                <div className="error-page">
                    <div className="main-plugin panel mb-6">
                        <h1 className="error-title">Something went wrong...</h1>
                        <h2 className="error-text">
                            Your security is important to us, which means your session has expired{" "}
                        </h2>
                        <p className="error-text">
                            Please return to <span
                            className="font-weight-semi-bold">{this.getAggregatorFullName()}</span> to retrieve your quote.
                        </p>
                    </div>
                </div>
                {this.pluginTemplates.renderFooter()}
            </React.Fragment>
        );
    }

    private getAggregatorFullName = () => {
        switch (this.props.params.aggregator) {
            case "cnf":
                return "confused.com";
            case "ctm":
                return "comparethemarket.com";
            case "msm":
                return "MoneySuperMarket";
            case "gc":
                return "Go.Compare";
            case "elx":
                return "ElectriX";
            default:
                return "aggregator";
        }
    }

}

export const AggregatorErrorPage = withRouter(AggregatorErrorPagePlain)
